import initialState from 'store/initial-state';

export default function appReducer(state = initialState.app, action) {
  switch (action.type) {
    default:
      return state;
  }
}
